import { getDefaultAgentMatcherPolicyUrl } from './getDefaultAgentMatcherPolicyUrl.mjs';
import { addAcrPolicyUrl } from '../policy/addAcrPolicyUrl.mjs';
import { addPolicyUrl } from '../policy/addPolicyUrl.mjs';

//
/** @hidden */
function setDefaultAgentMatcherPolicyThingIfNotExist(resource, name, mode) {
    const policyUrl = getDefaultAgentMatcherPolicyUrl(resource, name, mode);
    // TODO: Re-enable when we support setting agent access on member resources
    // if (policyUrl.includes("Member") && policyUrl.includes("Acr")) {
    //   return addMemberAcrPolicyUrl(resource, policyUrl);
    // }
    // if (policyUrl.includes("Member")) {
    //   return addMemberPolicyUrl(resource, policyUrl);
    // }
    if (policyUrl.includes("Acr")) {
        return addAcrPolicyUrl(resource, policyUrl);
    }
    return addPolicyUrl(resource, policyUrl);
}

export { setDefaultAgentMatcherPolicyThingIfNotExist };
